import { splitUid } from 'Services/WeaverUtils'

export getQueryFromCurrentItem = (data) ->
  if data.type is 'QUERY'
    if typeof data.data.query is "string"
      query = Object.assign(
        new Weaver.Query(),
        JSON.parse(data.data.query)
      )
    else
      query = data.data.query
  else if data.type is 'NODE'
    [id, graph] = splitUid(data.id)
    query = new Weaver.Query()
      .restrict([id])
      .inGraph(graph)
      .selectOut('*')
      .selectIn('*')
